import * as React from "react";
import { usePlpAnalytics } from "../plp-analytics-provider";

import { usePlpDataSourceProductListQuery } from "../plp-data-source-product-list-provider";
import { useReactPlpInitialState } from "../react-plp-intial-state-provider";

interface ProductListViewFreshResultsObserverProps {
  providerId: string;
}

export const ProductListViewFreshResultsObserver: React.FunctionComponent<
  ProductListViewFreshResultsObserverProps
> = (props) => {
  const thisProviderEventNameBase = `bbnt-plp-product-list-view-fresh-results-observer-${props.providerId}`;

  const { initialState } = useReactPlpInitialState();
  const { baseQuery } = initialState || {};
  const { search } = baseQuery || {};

  const { data } = usePlpDataSourceProductListQuery();
  const { analytics } = usePlpAnalytics();

  const [lastResponseId, setLastResponseId] = React.useState<
    string | undefined
  >();

  const handleFreshPlpLoadedState = React.useCallback(() => {
    const howManyPagesOfData = data?.pages?.length || 0;
    if (howManyPagesOfData === 1) {
      const lastPageFirstPage = data?.pages?.[0];
      if (lastPageFirstPage) {
        const thisResponseId = lastPageFirstPage.response_id;
        if (thisResponseId && thisResponseId !== lastResponseId) {
          analytics.onViewFredhopperListingPage({
            initialStateSearchTerms: search,
            fredhopperResponse: lastPageFirstPage,
          });
          setLastResponseId(thisResponseId);
        }
      }
    }
  }, [data, analytics, search, lastResponseId]);
  React.useEffect(() => {
    window.addEventListener(
      `${thisProviderEventNameBase}-fresh-plp-loaded`,
      handleFreshPlpLoadedState
    );
    return () => {
      window.removeEventListener(
        `${thisProviderEventNameBase}-fresh-plp-loaded`,
        handleFreshPlpLoadedState
      );
    };
  }, [data, analytics, search, lastResponseId, handleFreshPlpLoadedState]);

  React.useEffect(() => {
    const howManyPagesOfData = data?.pages?.length || 0;
    if (howManyPagesOfData === 1) {
      setTimeout(function () {
        window.dispatchEvent(
          new Event(`${thisProviderEventNameBase}-fresh-plp-loaded`)
        );
      }, 1500);
    }
  }, [data]);
  return <>{props?.children || []}</>;
};
